/**
 * API DocsHomeWidgets Section Template
 * By Srinivasa Upputuri <supputuri@svb.com> (www.svb.com)
 * Summary
 * This component renders Widgets section to the DocsHome
 */
import React, { useEffect, useState } from 'react';
import Loading from '@svb/api-loading-component/dist/components';
import { getDocsHomeDetails } from './helper';

/**
 * DocsHomeWidgets
 * @param contentUrl: url of the widgets content
 * @param title: title of this Widget
 * @returns DocsHomeWidget Cards Page with Cards
 */
const DocsHomeWidgets = ({ dataTestId, testMockContent, ...props }) => {
  const [loading, setLoading] = useState(true);
  const widgetsJson = dataTestId
    ? testMockContent
    : getDocsHomeDetails(props.contentUrl, 'widgets.json');
  useEffect(() => {
    if (widgetsJson.type === 'success') {
      setLoading(false);
    }
  }, [widgetsJson]);

  if (loading) {
    return <Loading />;
  }

  const apisCardsArray = [];
  const BuildFeatureSections = ({ apisJson }) => {
    return (
      <section className='container svb-container-fixed col-md-12 col-sm-12 mb-5 mt-5'>
        <div className='cards row'>
          {apisJson.map((item, index) => {
            let icon;
            try {
              icon =
                item?.cardIcon && require('@svb/svbbranding/dist/assets/icons/' + item?.cardIcon);
            } catch (error) {
              console.log(`Error: Cannot find icon ${item?.cardIcon}`);
              //fallback empty icon
              icon =
                "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
            }
            // const icon =
            //   item?.cardIcon !== ''
            //     ? require('@svb/svbbranding/dist/assets/icons/' + item?.cardIcon)
            //     : '';
            return (
              <div key={index} className='col-md-4 mb-3'>
                <div className={'card h-100 box-shadow-docs ' + item.cardBorder}>
                  <div className='card-header w-100'>
                    <img
                      src={icon}
                      className='docs-box-img'
                      width={40}
                      height={40}
                      alt='Docs Home Widget icon'
                      loading='lazy'
                    />
                  </div>
                  <div className='card-body'>
                    <h3 className='heading-medium'>{item.feature_name}</h3>
                    <ul className='list-unstyled'>
                      <li className='mb-2'>
                        {item?.link1 === 'noLink' ? (
                          <a>{item.feature_description1}</a>
                        ) : (
                          <a className='svb-text-link info no-href' href={item.link1}>
                            {item.feature_description1}
                          </a>
                        )}
                      </li>
                      <li>
                        {' '}
                        {item?.link2 === 'noLink' ? (
                          <a>{item.feature_description2}</a>
                        ) : (
                          <a className='svb-text-link info no-href' href={item.link2}>
                            {item.feature_description2}
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  };
  Object.keys(widgetsJson.response).map((key, i) => {
    apisCardsArray.push(<BuildFeatureSections key={i} apisJson={widgetsJson.response[key]} />);
  });
  return <>{apisCardsArray}</>;
};

export default DocsHomeWidgets;
